import {__} from '@wordpress/i18n';
import {useBlockProps} from '@wordpress/block-editor';

export default function Edit() {
    const blockProps = useBlockProps({
        className: 'wp-block-ipm-news row mb-3 mx-auto container',
    });

    function getRandomDateFormatted(startYear = 2000, endYear = 2025) {
        const start = new Date(`${startYear}-01-01`).getTime();
        const end = new Date(`${endYear}-12-31`).getTime();
        const randomTimestamp = Math.floor(Math.random() * (end - start)) + start;
        const randomDate = new Date(randomTimestamp);
        return randomDate.toISOString().slice(0, 10); // "YYYY-MM-DD"
    }

    return (
        <div {...blockProps}>
            {[1, 2, 3].map((item) => {
                    const randomDate = getRandomDateFormatted();
                    return (
                        <div key={item} className="col-xl-4 col-12 mr-3">
                            <div className="bem-news__item jsc-news__item">
                                <h3 className="bem-news__title">{__('Title will be generated')}</h3>
                                <p>
                            <span className="bem-news__cardpostdate">
                            {randomDate}
                            </span>
                                </p>
                                <div className="bem-news__excerpt">
                                    Placeholder entry, will be populated when loaded as visitor
                                </div>
                                <p className="bem-news__readmore">
                                    <a>Read the full news article</a>
                                </p>
                            </div>
                        </div>
                    )
                }
            )}
        </div>
    );
}
